export const HIGHLIGHT_CARD_TYPES = {
  LEAST_MISSED_QUESTION: 'LEAST_MISSED_QUESTION',
  MOST_MISSED_QUESTION: 'MOST_MISSED_QUESTION',
  HIGHEST_SCORING_METHODOLOGY: 'HIGHEST_SCORING_METHODOLOGY',
  LOWEST_SCORING_METHODOLOGY: 'LOWEST_SCORING_METHODOLOGY',
  LEAST_ARTICULATED_MESSAGE: 'LEAST_ARTICULATED_MESSAGE',
  USER_ENGAGEMENT: 'USER_ENGAGEMENT',
  USER_ENGAGEMENT_NEGATIVE: 'USER_ENGAGEMENT_NEGATIVE',
} as const;

export const HIGHLIGHT_CARD_HEADINGS: Record<string, string> = {
  [HIGHLIGHT_CARD_TYPES.LEAST_MISSED_QUESTION]: 'LEAST MISSED QUESTIONS',
  [HIGHLIGHT_CARD_TYPES.MOST_MISSED_QUESTION]: 'MOST MISSED QUESTIONS',
  [HIGHLIGHT_CARD_TYPES.HIGHEST_SCORING_METHODOLOGY]: 'HIGHEST SCORING METHODOLOGY SECTION',
  [HIGHLIGHT_CARD_TYPES.LOWEST_SCORING_METHODOLOGY]: 'LOWEST SCORING METHODOLOGY SECTION',
  [HIGHLIGHT_CARD_TYPES.LEAST_ARTICULATED_MESSAGE]: 'LEAST ARTICULATE MESSAGE',
  [HIGHLIGHT_CARD_TYPES.USER_ENGAGEMENT]: 'ENGAGEMENT',
};

export const HIGHLIGHT_CARD_PROGRESS_DESCRIPTIONS: Record<string, string> = {
  [HIGHLIGHT_CARD_TYPES.USER_ENGAGEMENT]: 'more sessions completed than team average',
  [HIGHLIGHT_CARD_TYPES.USER_ENGAGEMENT_NEGATIVE]: 'less sessions completed than team average',
  [HIGHLIGHT_CARD_TYPES.MOST_MISSED_QUESTION]: 'of the time, this user got this right.',
  [HIGHLIGHT_CARD_TYPES.LEAST_MISSED_QUESTION]: 'of the time, this user got this right.',
  [HIGHLIGHT_CARD_TYPES.LEAST_ARTICULATED_MESSAGE]: 'of the time, this user got this right.',
  [HIGHLIGHT_CARD_TYPES.HIGHEST_SCORING_METHODOLOGY]: 'avg. points on this objective.',
  [HIGHLIGHT_CARD_TYPES.LOWEST_SCORING_METHODOLOGY]: 'avg. points on this objective.',
};
